module.exports = __webpack_public_path__ + "static/media/cleany-logo-blue.65025a18.png";